export default "__VITE_ASSET__CpFCwTUu__"